"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.classIsInjectableFlagReflectKey = void 0;
exports.classIsInjectableFlagReflectKey = '@inversifyjs/core/classIsInjectableFlagReflectKey';
//# sourceMappingURL=classIsInjectableFlagReflectKey.js.map